import { useProductList } from '@jetshop/core/hooks/ProductList';
import React from 'react';
import { Link } from 'react-router-dom';
import FavouriteIcon from '../ui/icons/FavouriteIcon';
import { NumberBadge } from '../ui/NumberBadge';
import { theme } from '../Theming/Theming';

export function FavouriteCount({ className }) {
  const { count } = useProductList();
  return (
    <Link to={theme.config.routes.favourites.path} className={className}>
      {count > 0 && <NumberBadge text={count} />}
      <FavouriteIcon className="header-icon" />
    </Link>
  );
}
